"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortValue = exports.fromAPI = exports.toAPI = void 0;
var moment_1 = __importDefault(require("moment"));
var load_1 = require("../constants/load");
function toAPI(query) {
    var id__in = query.id__in, on_time_status = query.on_time_status, on_assignment_status = query.on_assignment_status, shipper_or_receiver__organization__in = query.shipper_or_receiver__organization__in, pickup_time = query.pickup_time, dropoff_time = query.dropoff_time, pickup_window = query.pickup_window, dropoff_window = query.dropoff_window, pickup_arrived_on = query.pickup_arrived_on, dropoff_completed_on = query.dropoff_completed_on, status__in = query.status__in, order__trailer_number = query.order__trailer_number, order__manifest__manifest_number = query.order__manifest__manifest_number, order__manifest__as400_manifest_number = query.order__manifest__as400_manifest_number, order__manifest__organization = query.order__manifest__organization, order__manifest__bill_of_lading_number = query.order__manifest__bill_of_lading_number, order__manifest__revenue_terminal = query.order__manifest__revenue_terminal, driver__revenue_terminal = query.driver__revenue_terminal, order__manifest__as400_status__in = query.order__manifest__as400_status__in, pickup_leg__driver__organization__in = query.pickup_leg__driver__organization__in, dropoff_leg__driver__organization__in = query.dropoff_leg__driver__organization__in, pickup__contact__organization__in = query.pickup__contact__organization__in, order__po_number_shipper = query.order__po_number_shipper, order__po_number_consignee = query.order__po_number_consignee, order__load_type = query.order__load_type, pickup__location__state__in = query.pickup__location__state__in, dropoff__contact__organization__in = query.dropoff__contact__organization__in, dropoff__location__state__in = query.dropoff__location__state__in, order__customer_order_number = query.order__customer_order_number, order__seal_number = query.order__seal_number, order__broker = query.order__broker, order__expedite__in = query.order__expedite__in, driver = query.driver, pickup__location__zip_code = query.pickup__location__zip_code, pickup__location__street1 = query.pickup__location__street1, pickup__location__street2 = query.pickup__location__street2, pickup__location__city = query.pickup__location__city, pickup__location__state = query.pickup__location__state, dropoff__location__zip_code = query.dropoff__location__zip_code, dropoff__location__street1 = query.dropoff__location__street1, dropoff__location__street2 = query.dropoff__location__street2, dropoff__location__city = query.dropoff__location__city, dropoff__location__state = query.dropoff__location__state, order__shipper__stop__name = query.order__shipper__stop__name, order__consignee__stop__name = query.order__consignee__stop__name, rest = __rest(query, ["id__in", "on_time_status", "on_assignment_status", "shipper_or_receiver__organization__in", "pickup_time", "dropoff_time", "pickup_window", "dropoff_window", "pickup_arrived_on", "dropoff_completed_on", "status__in", "order__trailer_number", "order__manifest__manifest_number", "order__manifest__as400_manifest_number", "order__manifest__organization", "order__manifest__bill_of_lading_number", "order__manifest__revenue_terminal", "driver__revenue_terminal", "order__manifest__as400_status__in", "pickup_leg__driver__organization__in", "dropoff_leg__driver__organization__in", "pickup__contact__organization__in", "order__po_number_shipper", "order__po_number_consignee", "order__load_type", "pickup__location__state__in", "dropoff__contact__organization__in", "dropoff__location__state__in", "order__customer_order_number", "order__seal_number", "order__broker", "order__expedite__in", "driver", "pickup__location__zip_code", "pickup__location__street1", "pickup__location__street2", "pickup__location__city", "pickup__location__state", "dropoff__location__zip_code", "dropoff__location__street1", "dropoff__location__street2", "dropoff__location__city", "dropoff__location__state", "order__shipper__stop__name", "order__consignee__stop__name"]);
    var result = __assign({}, rest);
    if (id__in && id__in.length > 0) {
        result.id__in = id__in.join(',');
    }
    if (on_time_status) {
        result.on_time_status = load_1.ON_TIME_STATUS_API[on_time_status];
    }
    if (on_assignment_status) {
        result.on_assignment_status =
            load_1.ON_ASSIGNMENT_STATUS_API[on_assignment_status];
    }
    if (order__manifest__manifest_number &&
        order__manifest__manifest_number.length > 0) {
        if (typeof order__manifest__manifest_number === 'string') {
            result.order__manifest__manifest_number__icontains = order__manifest__manifest_number;
        }
        else {
            result.order__manifest__manifest_number__in = order__manifest__manifest_number.toString();
        }
    }
    if (order__manifest__as400_manifest_number &&
        order__manifest__as400_manifest_number.length > 0) {
        if (typeof order__manifest__as400_manifest_number === 'string') {
            result.order__manifest__as400_manifest_number__icontains = order__manifest__as400_manifest_number;
        }
        else {
            result.order__manifest__as400_manifest_number__in = order__manifest__as400_manifest_number.toString();
        }
    }
    // if (
    //   order__manifest__organization__in &&
    //   order__manifest__organization__in.length > 0
    // ) {
    //   result.order__manifest__organization__in = order__manifest__organization__in.join(
    //     ',',
    //   );
    // }
    if (order__manifest__organization &&
        order__manifest__organization.length > 0) {
        if (typeof order__manifest__organization === 'string') {
            result.order__manifest__organization__name__icontains = order__manifest__organization;
        }
        else {
            result.order__manifest__organization__name__in = order__manifest__organization.join(',');
        }
    }
    if (order__manifest__revenue_terminal &&
        order__manifest__revenue_terminal.length > 0) {
        if (typeof order__manifest__revenue_terminal === 'string') {
            result.order__manifest__revenue_terminal__name__icontains = order__manifest__revenue_terminal;
        }
        else {
            result.order__manifest__revenue_terminal__name__in = order__manifest__revenue_terminal.join(',');
        }
    }
    if (driver__revenue_terminal && driver__revenue_terminal.length > 0) {
        if (typeof driver__revenue_terminal === 'string') {
            result.driver__revenue_terminal__name__icontains = driver__revenue_terminal;
        }
        else {
            result.driver__revenue_terminal__name__in = driver__revenue_terminal.join(',');
        }
    }
    if (order__manifest__as400_status__in &&
        order__manifest__as400_status__in.length > 0) {
        if (typeof order__manifest__as400_status__in === 'string') {
            result.order__manifest__as400_status__in = order__manifest__as400_status__in;
        }
        else {
            result.order__manifest__as400_status__in = order__manifest__as400_status__in.join(',');
        }
    }
    if (order__load_type && order__load_type.length > 0) {
        if (typeof order__load_type === 'string') {
            result.order__load_type__name__icontains = order__load_type;
        }
        else {
            result.order__load_type__name__in = order__load_type.join(',');
        }
    }
    if (order__trailer_number && order__trailer_number.length > 0) {
        if (typeof order__trailer_number === 'string') {
            result.order__trailer_number__icontains = order__trailer_number;
        }
        else {
            result.order__trailer_number__in = order__trailer_number.join(',');
        }
    }
    if (order__manifest__bill_of_lading_number &&
        order__manifest__bill_of_lading_number.length > 0) {
        if (typeof order__manifest__bill_of_lading_number === 'string') {
            result.order__manifest__bill_of_lading_number__icontains = order__manifest__bill_of_lading_number;
        }
        else {
            result.order__manifest__bill_of_lading_number__in = order__manifest__bill_of_lading_number.join(',');
        }
    }
    if (order__customer_order_number && order__customer_order_number.length > 0) {
        if (typeof order__customer_order_number === 'string') {
            result.order__customer_order_number__icontains = order__customer_order_number;
        }
        else {
            result.order__customer_order_number__in = order__customer_order_number.join(',');
        }
    }
    if (order__shipper__stop__name && order__shipper__stop__name.length > 0) {
        if (typeof order__shipper__stop__name === 'string') {
            result.order__shipper__stop__name__icontains = order__shipper__stop__name;
        }
        else {
            result.order__shipper__stop__name__in = order__shipper__stop__name.join(',');
        }
    }
    if (order__consignee__stop__name && order__consignee__stop__name.length > 0) {
        if (typeof order__consignee__stop__name === 'string') {
            result.order__consignee__stop__name__icontains = order__consignee__stop__name;
        }
        else {
            result.order__consignee__stop__name__in = order__consignee__stop__name.join(',');
        }
    }
    if (order__po_number_shipper && order__po_number_shipper.length > 0) {
        if (typeof order__po_number_shipper === 'string') {
            result.order__po_number_shipper__icontains = order__po_number_shipper;
        }
        else {
            result.order__po_number_shipper__in = order__po_number_shipper.join(',');
        }
    }
    if (order__po_number_consignee && order__po_number_consignee.length > 0) {
        if (typeof order__po_number_consignee === 'string') {
            result.order__po_number_consignee__icontains = order__po_number_consignee;
        }
        else {
            result.order__po_number_consignee__in = order__po_number_consignee.join(',');
        }
    }
    if (order__seal_number && order__seal_number.length > 0) {
        if (typeof order__seal_number === 'string') {
            result.order__seal_number__icontains = order__seal_number;
        }
        else {
            result.order__seal_number__in = order__seal_number.join(',');
        }
    }
    if (order__expedite__in && order__expedite__in.length > 0) {
        if (typeof order__expedite__in === 'string') {
            result.order__expedite__in = order__expedite__in;
        }
        else {
            result.order__expedite__in = order__expedite__in.join(',');
        }
    }
    if (driver && driver.length > 0) {
        if (typeof driver === 'string') {
            result.driver__name__icontains = driver;
        }
        else {
            result.driver__name__in = driver.join(';');
        }
    }
    if (order__broker && order__broker.length > 0) {
        if (typeof order__broker === 'string') {
            result.order__broker__icontains = order__broker;
        }
        else {
            result.order__broker__in = order__broker.join(',');
        }
    }
    if (status__in && status__in.length > 0) {
        if (typeof status__in === 'string') {
            if (status__in === 'None') {
                result.status__in = 'None';
            }
            else {
                result.status__in = (0, load_1.getAPIStatus)(status__in);
            }
        }
        else {
            result.status__in = status__in
                .map(function (status) { return (0, load_1.getAPIStatus)(status); })
                .join(',');
        }
    }
    if (pickup_leg__driver__organization__in &&
        pickup_leg__driver__organization__in.length > 0) {
        result.pickup_leg__driver__organization__in = pickup_leg__driver__organization__in.join(',');
    }
    if (dropoff_leg__driver__organization__in &&
        dropoff_leg__driver__organization__in.length > 0) {
        result.dropoff_leg__driver__organization__in = dropoff_leg__driver__organization__in.join(',');
    }
    if (pickup__contact__organization__in &&
        pickup__contact__organization__in.length > 0) {
        if (typeof pickup__contact__organization__in === 'string') {
            result.pickup__contact__organization__in = pickup__contact__organization__in;
        }
        else {
            result.pickup__contact__organization__in = pickup__contact__organization__in.join(',');
        }
    }
    if (dropoff__contact__organization__in &&
        dropoff__contact__organization__in.length > 0) {
        if (typeof dropoff__contact__organization__in === 'string') {
            result.dropoff__contact__organization__in = dropoff__contact__organization__in;
        }
        else {
            result.dropoff__contact__organization__in = dropoff__contact__organization__in.join(',');
        }
    }
    if (shipper_or_receiver__organization__in &&
        shipper_or_receiver__organization__in.length > 0) {
        result.shipper_or_receiver__organization__in = shipper_or_receiver__organization__in.join(',');
    }
    if (pickup_window) {
        var from = pickup_window.from, to = pickup_window.to;
        result.pickup_window_after = (0, moment_1.default)(from).toISOString();
        result.pickup_window_before = (0, moment_1.default)(to).toISOString();
    }
    if (pickup_arrived_on) {
        var from = pickup_arrived_on.from, to = pickup_arrived_on.to;
        result.pickup_arrived_on_after = (0, moment_1.default)(from).toISOString();
        result.pickup_arrived_on_before = (0, moment_1.default)(to).toISOString();
    }
    if (dropoff_time) {
        var from = dropoff_time.from, to = dropoff_time.to;
        result.dropoff_time_after = (0, moment_1.default)(from).toISOString();
        result.dropoff_time_before = (0, moment_1.default)(to).toISOString();
    }
    if (dropoff_completed_on) {
        var from = dropoff_completed_on.from, to = dropoff_completed_on.to;
        result.dropoff_completed_on_after = (0, moment_1.default)(from).toISOString();
        result.dropoff_completed_on_before = (0, moment_1.default)(to).toISOString();
    }
    if (pickup_time) {
        var from = pickup_time.from, to = pickup_time.to;
        result.pickup_time_after = (0, moment_1.default)(from).toISOString();
        result.pickup_time_before = (0, moment_1.default)(to).toISOString();
    }
    if (dropoff_window) {
        var from = dropoff_window.from, to = dropoff_window.to;
        result.dropoff_window_after = (0, moment_1.default)(from).toISOString();
        result.dropoff_window_before = (0, moment_1.default)(to).toISOString();
    }
    if (pickup__location__street1 && pickup__location__street1.length > 0) {
        if (typeof pickup__location__street1 === 'string') {
            result.pickup__location__street1__icontains = pickup__location__street1;
        }
        else {
            result.pickup__location__street1__in = pickup__location__street1.join(',');
        }
    }
    if (pickup__location__street2 && pickup__location__street2.length > 0) {
        if (typeof pickup__location__street2 === 'string') {
            result.pickup__location__street2__icontains = pickup__location__street2;
        }
        else {
            result.pickup__location__street2__in = pickup__location__street2.join(',');
        }
    }
    if (pickup__location__city && pickup__location__city.length > 0) {
        if (typeof pickup__location__city === 'string') {
            result.pickup__location__city__icontains = pickup__location__city;
        }
        else {
            result.pickup__location__city__in = pickup__location__city.join(',');
        }
    }
    if (pickup__location__state && pickup__location__state.length > 0) {
        if (typeof pickup__location__state === 'string') {
            result.pickup__location__state__icontains = pickup__location__state;
        }
        else {
            result.pickup__location__state__in = pickup__location__state.join(',');
        }
    }
    if (pickup__location__zip_code && pickup__location__zip_code.length > 0) {
        if (typeof pickup__location__zip_code === 'string') {
            result.pickup__location__zip_code__icontains = pickup__location__zip_code;
        }
        else {
            result.pickup__location__zip_code__in = pickup__location__zip_code.join(',');
        }
    }
    if (dropoff__location__street1 && dropoff__location__street1.length > 0) {
        if (typeof dropoff__location__street1 === 'string') {
            result.dropoff__location__street1__icontains = dropoff__location__street1;
        }
        else {
            result.dropoff__location__street1__in = dropoff__location__street1.join(',');
        }
    }
    if (dropoff__location__street2 && dropoff__location__street2.length > 0) {
        if (typeof dropoff__location__street2 === 'string') {
            result.dropoff__location__street2__icontains = dropoff__location__street2;
        }
        else {
            result.dropoff__location__street2__in = dropoff__location__street2.join(',');
        }
    }
    if (dropoff__location__city && dropoff__location__city.length > 0) {
        if (typeof dropoff__location__city === 'string') {
            result.dropoff__location__city__icontains = dropoff__location__city;
        }
        else {
            result.dropoff__location__city__in = dropoff__location__city.join(',');
        }
    }
    if (dropoff__location__state && dropoff__location__state.length > 0) {
        if (typeof dropoff__location__state === 'string') {
            result.dropoff__location__state__icontains = dropoff__location__state;
        }
        else {
            result.dropoff__location__state__in = dropoff__location__state.join(',');
        }
    }
    if (dropoff__location__zip_code && dropoff__location__zip_code.length > 0) {
        if (typeof dropoff__location__zip_code === 'string') {
            result.dropoff__location__zip_code__icontains = dropoff__location__zip_code;
        }
        else {
            result.dropoff__location__zip_code__in = dropoff__location__zip_code.join(',');
        }
    }
    if (pickup__location__state__in && pickup__location__state__in.length > 0) {
        if (typeof pickup__location__state__in === 'string') {
            result.pickup__location__state__in = pickup__location__state__in;
        }
        else {
            result.pickup__location__state__in = pickup__location__state__in.join(',');
        }
    }
    if (dropoff__location__state__in && dropoff__location__state__in.length > 0) {
        if (typeof dropoff__location__state__in === 'string') {
            result.dropoff__location__state__in = dropoff__location__state__in;
        }
        else {
            result.dropoff__location__state__in = dropoff__location__state__in.join(',');
        }
    }
    return result;
}
exports.toAPI = toAPI;
function fromAPI(querystring) {
    var id__in = querystring.id__in, on_time_status = querystring.on_time_status, on_assignment_status = querystring.on_assignment_status, shipper_or_receiver__organization__in = querystring.shipper_or_receiver__organization__in, pickup_time_before = querystring.pickup_time_before, pickup_time_after = querystring.pickup_time_after, pickup_window_before = querystring.pickup_window_before, pickup_window_after = querystring.pickup_window_after, dropoff_time_before = querystring.dropoff_time_before, dropoff_time_after = querystring.dropoff_time_after, dropoff_window_before = querystring.dropoff_window_before, dropoff_window_after = querystring.dropoff_window_after, pickup_arrived_on_after = querystring.pickup_arrived_on_after, pickup_arrived_on_before = querystring.pickup_arrived_on_before, dropoff_completed_on_after = querystring.dropoff_completed_on_after, dropoff_completed_on_before = querystring.dropoff_completed_on_before, order__load_type__name__in = querystring.order__load_type__name__in, status__in = querystring.status__in, order__manifest__organization__in = querystring.order__manifest__organization__in, driver__revenue_terminal__name__in = querystring.driver__revenue_terminal__name__in, order__manifest__revenue_terminal__name__in = querystring.order__manifest__revenue_terminal__name__in, pickup_leg__driver__organization__in = querystring.pickup_leg__driver__organization__in, dropoff_leg__driver__organization__in = querystring.dropoff_leg__driver__organization__in, pickup__contact__organization__in = querystring.pickup__contact__organization__in, pickup__location__state__in = querystring.pickup__location__state__in, dropoff__contact__organization__in = querystring.dropoff__contact__organization__in, dropoff__location__state__in = querystring.dropoff__location__state__in, driver__revenue_terminal__in = querystring.driver__revenue_terminal__in, order__manifest__revenue_terminal__in = querystring.order__manifest__revenue_terminal__in, order__load_type__in = querystring.order__load_type__in, rest = __rest(querystring, ["id__in", "on_time_status", "on_assignment_status", "shipper_or_receiver__organization__in", "pickup_time_before", "pickup_time_after", "pickup_window_before", "pickup_window_after", "dropoff_time_before", "dropoff_time_after", "dropoff_window_before", "dropoff_window_after", "pickup_arrived_on_after", "pickup_arrived_on_before", "dropoff_completed_on_after", "dropoff_completed_on_before", "order__load_type__name__in", "status__in", "order__manifest__organization__in", "driver__revenue_terminal__name__in", "order__manifest__revenue_terminal__name__in", "pickup_leg__driver__organization__in", "dropoff_leg__driver__organization__in", "pickup__contact__organization__in", "pickup__location__state__in", "dropoff__contact__organization__in", "dropoff__location__state__in", "driver__revenue_terminal__in", "order__manifest__revenue_terminal__in", "order__load_type__in"]);
    var result = __assign({}, rest);
    if (id__in) {
        result.id__in = id__in.split(',').map(function (id) { return parseInt(id, 10); });
    }
    if (on_time_status) {
        result.on_time_status = load_1.ON_TIME_STATUS_FROM_API[on_time_status];
    }
    if (on_assignment_status) {
        result.on_assignment_status =
            load_1.ON_ASSIGNMENT_STATUS_FROM_API[on_assignment_status];
    }
    if (order__manifest__organization__in) {
        result.order__manifest__organization__in = order__manifest__organization__in
            .split(',')
            .map(function (organization) { return parseInt(organization, 10); });
    }
    if (driver__revenue_terminal__in) {
        result.driver__revenue_terminal__in = driver__revenue_terminal__in
            .split(',')
            .map(function (location) { return parseInt(location, 10); });
    }
    if (driver__revenue_terminal__name__in) {
        result.driver__revenue_terminal = driver__revenue_terminal__name__in.split(',');
    }
    if (order__manifest__revenue_terminal__in) {
        result.order__manifest__revenue_terminal__in = order__manifest__revenue_terminal__in
            .split(',')
            .map(function (location) { return parseInt(location, 10); });
    }
    if (order__manifest__revenue_terminal__name__in) {
        result.order__manifest__revenue_terminal = order__manifest__revenue_terminal__name__in.split(',');
    }
    if (order__load_type__in) {
        result.order__load_type__in = order__load_type__in
            .split(',')
            .map(function (loadType) { return parseInt(loadType, 10); });
    }
    if (status__in) {
        result.status__in = status__in
            .split(',')
            .map(function (status) { return status; });
    }
    if (pickup_leg__driver__organization__in) {
        result.pickup_leg__driver__organization__in = pickup_leg__driver__organization__in
            .split(',')
            .map(function (organization) { return parseInt(organization, 10); });
    }
    if (dropoff_leg__driver__organization__in) {
        result.dropoff_leg__driver__organization__in = dropoff_leg__driver__organization__in
            .split(',')
            .map(function (organization) { return parseInt(organization, 10); });
    }
    // if (dropoff__contact__organization__in) {
    //   result.dropoff__contact__organization__in = dropoff__contact__organization__in
    //     .split(',')
    //     .map(organization => parseInt(organization, 10));
    // }
    // if (shipper__contact__organization__in) {
    //   result.shipper__contact__organization__in = shipper__contact__organization__in
    //     .split(',')
    //     .map(organization => parseInt(organization, 10));
    // }
    if (shipper_or_receiver__organization__in) {
        result.shipper_or_receiver__organization__in = shipper_or_receiver__organization__in
            .split(',')
            .map(function (organization) { return parseInt(organization, 10); });
    }
    if (pickup_time_after && pickup_time_before) {
        result.pickup_time = {
            from: (0, moment_1.default)(pickup_time_after),
            to: (0, moment_1.default)(pickup_time_before),
        };
    }
    if (pickup_window_after && pickup_window_before) {
        result.pickup_window = {
            from: (0, moment_1.default)(pickup_window_after),
            to: (0, moment_1.default)(pickup_window_before),
        };
    }
    if (pickup_arrived_on_after && pickup_arrived_on_before) {
        result.pickup_arrived_on = {
            from: (0, moment_1.default)(pickup_arrived_on_after),
            to: (0, moment_1.default)(pickup_arrived_on_before),
        };
    }
    if (dropoff_completed_on_after && dropoff_completed_on_before) {
        result.dropoff_completed_on = {
            from: (0, moment_1.default)(dropoff_completed_on_after),
            to: (0, moment_1.default)(dropoff_completed_on_before),
        };
    }
    if (dropoff_time_after && dropoff_time_before) {
        result.dropoff_time = {
            from: (0, moment_1.default)(dropoff_time_before),
            to: (0, moment_1.default)(dropoff_time_after),
        };
    }
    if (dropoff_window_after && dropoff_window_before) {
        result.dropoff_window = {
            from: (0, moment_1.default)(dropoff_window_before),
            to: (0, moment_1.default)(dropoff_window_after),
        };
    }
    // if (shipper__location__state__in) {
    //   result.shipper__location__state__in = shipper__location__state__in.split(
    //     ',',
    //   );
    // }
    // if (consignee__location__state__in) {
    //   result.consignee__location__state__in = consignee__location__state__in.split(
    //     ',',
    //   );
    // }
    return result;
}
exports.fromAPI = fromAPI;
function getSortValue(columnId) {
    switch (columnId) {
        case 'order__manifest__manifest_number__icontains':
            return 'order__manifest__manifest_number';
        case 'order__manifest__bill_of_lading_number__icontains':
            return 'order__manifest__bill_of_lading_number';
        case 'driver__revenue_terminal__name__in':
            return 'driver__revenue_terminal';
        case 'order__manifest__revenue_terminal__name__in':
            return 'order__manifest__revenue_terminal';
        case 'order__manifest__organization__name__icontains':
            return 'order__manifest__organization';
        case 'load_type__name__icontains':
            return 'load_type';
        case 'load_notes__icontains':
            return 'load_notes';
        case 'load_weight__icontains':
            return 'load_weight';
        case 'estimated_travel_distance__icontains':
            return 'estimated_travel_distance';
        case 'status__in':
            return 'status';
        case 'broker__icontains':
            return 'broker';
        case 'seal_number__icontains':
            return 'seal_number';
        case 'trailer_number__icontains':
            return 'trailer_number';
        case 'pickup_window':
            return 'shipper__window';
        case 'shipper__contact__name__icontains':
            return 'shipper__contact__organization';
        case 'shipper__pickup_number__icontains':
            return 'shipper__pickup_number';
        case 'shipper__location__street1__icontains':
            return 'shipper__location__street1';
        case 'shipper__location__street2__icontains':
            return 'shipper__location__street2';
        case 'shipper__location__city__icontains':
            return 'shipper__location__city';
        case 'shipper__location__state__icontains':
            return 'shipper__location__state';
        case 'shipper__location__zip_code__icontains':
            return 'shipper__location__zip_code';
        case 'dropoff_window':
            return 'consignee__window';
        case 'consignee__contact__name__icontains':
            return 'consignee__contact__organization';
        case 'consignee__pickup_number__icontains':
            return 'consignee__pickup_number';
        case 'consignee__location__street1__icontains':
            return 'consignee__location__street1';
        case 'consignee__location__street2__icontains':
            return 'consignee__location__street2';
        case 'consignee__location__city__icontains':
            return 'consignee__location__city';
        case 'consignee__location__state__in':
            return 'consignee__location__state';
        case 'consignee__location__zip_code__icontains':
            return 'consignee__location__zip_code';
        default:
            return columnId;
    }
}
exports.getSortValue = getSortValue;
